export const ActionImageRenderer = (props: any) =>
    <a href={'/gridApi/actionimage/download/' + props.data.no + '/' + props.value}
       target="_blank" rel="noreferrer">
        {props.value}
    </a>